import Vue from 'vue'
import { createStore } from 'vuex'

// Modules
import user from './common/user'
import energyOrganisation from './energy/organisation'
import bankOrganisation from './banking/organisation'
import customer from './common/customer'
import bankIndustry from './banking/industry'
import bankCategory from './banking/bankCategory'
import productBlacklist from './banking/productBlacklist'
import energyIndustry from './energy/industry'
import sso from "./common/sso"
import roadmaps from './common/roadmaps'
import usage from './common/usage'
import suppliersQuestions from './suppliers/questions'
import marketProducts from './bankwatch/marketProducts'
import bankwatchUser from './bankwatch/user'
import broker from './bankwatch/broker'
import bankwatchDashboard from './bankwatch/dashboard'
import { IFetchable, IUserProfile } from '@/domain/common';
import { UserProfile } from '@/domain/UserProfile';

class State {
    // Sign in params
    public showSecure: boolean = false
    public showSignIn: boolean = true
    public postLoginRoute: string = '/landing'
    public $auth: any
    public apiBase: string = ''

    public currentUser: IUserProfile & IFetchable<IUserProfile> = new UserProfile()

    public newCreateHolder: any = {}

    // Product Switcher
    public currentProduct: 'productcloud' | 'bankwatch' | 'cdrtest' = 'productcloud'
}

const store = createStore({
    state: new State(),

    mutations: {
        logout(state:State) {
            state.currentUser = new UserProfile()
        },
        loginStart(state:State) {
        },
        loginComplete(state:State) {
            state.currentUser = new UserProfile()
            if (state.$auth.isAuthenticated) {
                state.currentUser.fetch();
            }
        },
        setCurrentProduct(state: State, product: 'productcloud' | 'bankwatch' | 'cdrtest') {
            state.currentProduct = product
        }
    },
    actions: {
    },
    modules: {
        user,
        customer,
        roadmaps,
        usage,
        bankOrganisation,
        energyOrganisation,
        bankIndustry,
        bankCategory,
        productBlacklist,
        energyIndustry,
        suppliersQuestions,
        sso,
        marketProducts,
        bankwatchUser,
        broker,
        bankwatchDashboard
    }
})

export default store
